export default __webpack_public_path__ + "static/media/3_capsule.d59f05ef.jpg";